import {useFunctions} from "reactfire";
import React, { useEffect, useState } from "react";
import BarLoader from "react-spinners/BarLoader";
import { FormGroup, Container, Row, Col } from "react-bootstrap";
import Alert from "../../../../shared/components/alert/Alert";
import { useHistory } from "react-router-dom";
import { useAppUser } from "../../../../contexts/user-context/UserContext";
import SuccsessAlert from "../../../../shared/components/alert/successAlert";
import FormValidator from "../../../../shared/utils/FormValidator";

interface IState {
  email: string;
  hasError: boolean;
  errorMessage: string;
  inlineErrorMessage: string;
  isSuccess: boolean;
  loading: boolean;
}

const initState: IState = {
  email: "",
  hasError: false,
  errorMessage: "",
  inlineErrorMessage: "",
  isSuccess: false,
  loading: false,
};

const PasswordResetForm = () => {
  const [state, setState] = useState(initState);
  const resetUserPasswordCF = useFunctions().httpsCallable("resetUserPassword");
  const history = useHistory();
  const appUser = useAppUser();

  useEffect(() => {
    if (localStorage.getItem('isAuthed') === 'true' || appUser.fireUser) {
      history.push("/dashboard/home");
    }
  }, [appUser, history]);

  const resetUserPassword = () => {
    setState({ ...state, loading: true });
    resetUserPasswordCF(state.email)
      .then((data) => {
        setState({
          ...state,
          isSuccess: true,
          hasError: false,
          errorMessage: "",
          inlineErrorMessage: ""
        });
      })
      .catch((errorResp) => {
        setState({
          ...state,
          isSuccess: false,
          hasError: true,
          errorMessage: errorResp.message.includes("Not Found!") ? "Email not found" : "An error occurred!",
          inlineErrorMessage: ""
        });
      })
      .finally(() => {
        setState((ps) => ({ ...ps, loading: false }));
      });
  };

  const validateFormData = (): boolean => {
    const fnValidation = FormValidator.validateEmail(state.email);

    setState({
      ...state,
      inlineErrorMessage: fnValidation.message,
    });

    return (
      fnValidation.isValid
    );
  };

  return (
    <Container className="h-100">
      <Row className="h-100 justify-content-center ">
        <Col
          xs={12}
          style={{ marginTop: "13%" }}
          className="d-flex justify-content-center "
        >
          <div style={{ width: "550px" }}>
            <form
              onSubmit={(e: any) => {
                e.preventDefault();
                !state.loading && validateFormData() && resetUserPassword();
              }}
            >
              <FormGroup style={{ marginBottom: "35px" }}>
                <h1
                  className="text-center color-white"
                  style={{ fontSize: "30px" }}
                >
                  Reset Password for Your Innovation Nation Account
                </h1>
              </FormGroup>

              {state.hasError && (
                <FormGroup>
                  <Alert
                    show={state.hasError}
                    onClose={() => setState({ ...state, hasError: false, errorMessage: "" })}
                  >
                    <b>ERROR!</b> {state.errorMessage}
                  </Alert>
                </FormGroup>
              )}
              {state.isSuccess && (
                <FormGroup>
                  <SuccsessAlert
                    show={state.isSuccess}
                    onClose={() => setState({ ...state, isSuccess: false })}
                  >
                    <b>Email Sent Successfully!</b>
                  </SuccsessAlert>
                </FormGroup>
              )}

              <div style={{ paddingLeft: "75px", paddingRight: "75px" }}>
                <FormGroup>
                  <input
                    className="login-input"
                    placeholder="Email"
                    value={state.email}
                    onChange={(e) => {
                      setState({ ...state,
                        email: e.target.value,
                        isSuccess: false,
                        hasError: false,
                        errorMessage: "",
                        inlineErrorMessage: ""
                      });
                    }}
                  />
                  <label className="error-message-glow">
                    {state.inlineErrorMessage}
                  </label>
                </FormGroup>
                {state.loading && (
                  <FormGroup>
                    <BarLoader
                      height={4}
                      width={"100%"}
                      color={"#fff"}
                      loading={state.loading}
                    />
                  </FormGroup>
                )}
                <FormGroup className="text-center">
                  <button className="login-button" type="submit">
                    Send Password Reset Email
                  </button>
                </FormGroup>
              </div>
            </form>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default PasswordResetForm;
